// 鼠标滚动横向滚动
export default {
  mounted(el) {
    const handler = (e) => {
      e.preventDefault()
      el.scrollLeft += e.deltaY
    }
    
    el.addEventListener('wheel', handler, { passive: false })
    el._scrollXHandler = handler  // 保存引用用于卸载
  },
  beforeUnmount(el) {
    if (el._scrollXHandler) {
      el.removeEventListener('wheel', el._scrollXHandler)
      el._scrollXHandler = null
    }
  }
}